import {
  GET_ALLOW_PROFILE,
  GET_ALLOW_PROFILE_FAILED,
  GET_ALLOW_PROFILE_SUCCESS,
  RESET_TIN,
  SEARCH_TIN,
  SEARCH_TIN_FAILED,
  SEARCH_TIN_SUCCESS,
  VALIDATE_TIN,
  VALIDATE_TIN_FAILED,
  VALIDATE_TIN_SUCCESS,
} from "./constans";

export const validateTin = ({ payload, callback }) => {
  return {
    type: VALIDATE_TIN,
    payload,
    callback,
  };
};

export const validateTinSuccess = payload => {
  return {
    type: VALIDATE_TIN_SUCCESS,
    payload,
  };
};
export const validateTinFailed = () => {
  return {
    type: VALIDATE_TIN_FAILED,
  };
};

export const resetTin = payload => {
  return {
    type: RESET_TIN,
    payload,
  };
};

export const searchTin = payload => {
  return {
    type: SEARCH_TIN,
    payload,
  };
};

export const searchTinSuccess = payload => {
  return {
    type: SEARCH_TIN_SUCCESS,
    payload,
  };
};

export const searchTinFailed = () => {
  return {
    type: SEARCH_TIN_FAILED,
  };
};

export const getAllowProfile = () => {
  return {
    type: GET_ALLOW_PROFILE,
  };
};
export const getAllowProfileSuccess = payload => {
  return {
    type: GET_ALLOW_PROFILE_SUCCESS,
    payload,
  };
};
export const getAllowProfileFailed = () => {
  return {
    type: GET_ALLOW_PROFILE_FAILED,
  };
};
